import { useRouter } from "next/router";
import { CategoryItem, CrumbItem } from "@/lib/constants";
import BreadCrumbItem from "./BreadCrumbItem";
import { useCategoriesStore } from "@/stores/useCategoriesStore";
import { useEffect, useState } from "react";


interface BreadcrumbsProps {
  customName: string | null;
}

const Breadcrumbs = (props: BreadcrumbsProps) => {
  const { categories, getCategories } = useCategoriesStore();
  const [categoriesData, setCategoriesData] = useState(getCategories());
  const router = useRouter();

  useEffect(() => {
    setCategoriesData(getCategories());
  }, [categories, getCategories])

  function breadcrumb(path: string | string[] | undefined, p_categories: CategoryItem[] | null) {
    let path_list: CrumbItem[] = [{name: 'Home', url: '/', custom_link: null, link: true}];
    let category_list = p_categories;
    let url: string | null = '/product-category';

    if (props.customName !== null && props.customName !== undefined && props.customName.length > 0) {
      path_list.push({name: props.customName, url: null, custom_link: null, link: false});
    } else if (path !== undefined && p_categories !== null) {
      if (Array.isArray(path)) {
        for (let i = 0; i < path.length; i++) {
          let cc: CategoryItem[] = []
          let custom_link: string | null = null;

          if (category_list != null) {
            cc = category_list.filter((category) => category.slug === path[i]);
          } else {
            cc = p_categories.filter((category) => category.slug === path[i]);
          }

          if (cc.length > 0) {
            if (cc[0].slug === "brands") {
              custom_link = "/brand/"
            }

            if (path_list[path_list.length - 1].name === "Brands") {
              path_list[path_list.length - 1].custom_link += cc[0].slug;
            }

            url += '/' + cc[0].slug;

            if (i === path.length - 1) {
              path_list.push({
                name: (path_list.length > 0 && path_list[path_list.length - 1].name !== "Brands" ? cc[0].name : cc[0].name.split("-")[0]),
                url: url,
                custom_link: custom_link,
                link: (i < path.length - 1)
              });
            }
            category_list = cc[0].subcategory;
          }
        }
      } else if (category_list != null) {
        let cc = category_list.filter((category) => category.slug === path);

        if (cc.length > 0) {
          path_list.push({name: cc[0].name, url: cc[0].slug, custom_link: null, link: false});
        }
      }
    }

    return path_list
  }

  return (
    <div className="container">
      <div className="flex md:px-3 md:py-2 my-6 text-xs font-poppins">
        {breadcrumb(router.query.slug, categoriesData.data).map((path, index) => (
          <div key={index} className="flex">
            {index === 0 ? (
              <BreadCrumbItem name={path.name} url={path.url} custom_link={path.custom_link} link={path.link} />
            ) : (
              <>
                <span className="mx-3">&gt;</span>
                <BreadCrumbItem name={path.name} url={path.url} custom_link={path.custom_link} link={path.link} />
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default Breadcrumbs
